import * as NS from './namespace';
import { Module } from 'vuex';

import actions from './actions';
import getters from './getters';
import mutations from './mutations';

/**
 * Состояние по умолчанию модуля просмотра
 */
const defaultState: NS.IViewingState = {
    preloader: false,
    failLoading: false,
    activeFormRequest: false,
    failedFormRequest: false,

    activeDevices: [],
    abailableIndicators: [],
    indictorValuesGrid: [],
    indictorValuesGrids: {},

    activeUploadRequest: false,
    failedUploadRequest: false,
    successUploadRequest: false,
};

const ViewingModule: Module<NS.IViewingState, NS.IViewingState> = {
    namespaced: true,
    actions: {
        ...actions,
    },
    getters: {
        ...getters,
    },
    mutations: {
        ...mutations,
    },
    state: {
        ...defaultState,
    },
};

/**
 * Модуль просмотра для хранилища
 */
export default ViewingModule;